import { computed, ref, watch } from '@vue/composition-api'

interface CountTimeParams {
    totalTime: number
}

export const useCountTime = ({ totalTime }: CountTimeParams) => {
    const now = ref(0)
    const time = ref(totalTime)
    let isRunning = false

    const onStart = () => {
        now.value = Date.now()
        if (time.value > 0) {
            isRunning = true
            requestAnimationFrame(onStart)
        } else {
            isRunning = false
        }
    }


    
    const finishTime = computed(() => Date.now() + time.value)
    
    const countdown = computed(() => Math.max(0, finishTime.value - now.value))

    const initTime = (initTimeNum: number) => {
        time.value = initTimeNum
        if (!isRunning) {
            onStart()
        }
    }

    watch(
        () => countdown.value,
        () => {
            if (0 === countdown.value) {
                // finish
            }
        }
    )
    return {
        countdown,
        onStart,
        initTime
    }
}
